
import * as constants from '../constants';

const util_isEmpty = (str) => {
    return (!str || str.length === 0 );
};
const util_isNotEmpty = (str) => {
    return !(!str || str.length === 0 );
};
const util_isObjectEmpty = (objectName) => {
    return Object.keys(objectName).length === 0;
};
const util_isObjectNotEmpty = (objectName) => {
    return Object.keys(objectName).length !== 0;
};
var util_getPostDataFetchKey = async (_dp_link_uri, type=1) => {
    try {
        //var keyData = null;
        //console.log("-------util_getPostDataFetchKey---------1-");
        // var body = {
        //     "User_TokenKey": id,
        //     "User_Friends_TokenKey": id
        // }
        var dlu = constants.deepLinkModulePF; // type=1 profile
        if(type==2) // posts deep link uri type=2 posts
        {
            // deepLiTkModulePT
            dlu = constants.deepLiTkModulePT;
        }

        return await fetch(constants.API_BASE_URL_DeepLinkModule + dlu + "/" + _dp_link_uri, {
            method: 'POST',
            //body: JSON.stringify(body),
            //title: title,
            reqId: Math.random().toString(36).slice(2),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
            mode: "cors", // required in frontend
        });
        // .then((response) => response.json())
        // .then((data) => {   
        //     var d = 0;  
        //     console.log("data:",data); 
        //     keyData = postData;
        //     return data;
        //     /*
        //         code
        //             : 
        //             404
        //         data
        //             : 
        //             []
        //         message
        //             : 
        //             "Page not found..."
        //         status
        //             : 
        //             false       
                    
        //         Method-POST
        //         {
        //             "code": 200,
        //             "message": "Get Link Data!",
        //             "data": {
        //                 "User_TokenKey": "22a9a9b6e3ea868aa64b3e539d4f440e"
        //             }
        //         }  

        //         {
        //             "code": 200,
        //             "message": "Get Link Data!",
        //             "data": {
        //                 "User_TokenKey": "22a9a9b6e3ea868aa64b3e539d4f440e"
        //             }
        //         }
                    
        //         {
        //             "status":false,
        //             "code":404,
        //             "data":[],
        //             "message":"Page not found..."
        //         }
        //         {
        //             "code": 200,
        //             "status": true,
        //             "message": "Get Link Data!",
        //             "data": {
        //                 "User_TokenKey": "22a9a9b6e3ea868aa64b3e539d4f440e"
        //             }
        //         }
        //     */         
        //     if(data.status && data.code == 200 && data.data != undefined)
        //     {
        //         var postData = data.data;
        //         console.log("postData:",postData);
        //         //if(postData != undefined && postData != null && postData.length >0)
        //         if(postData.User_TokenKey != undefined && postData.User_TokenKey.length > 0)
        //         {
        //             d = 1;
        //             //const postDataReversed = postData.reverse();                    
        //             //setFetchedPostData(data);
        //             //setDataFetchKey(postData.User_TokenKey);
        //             //getPostData(postData.User_TokenKey, "Post Details", {}); 
        //             keyData = postData;
        //             console.log("-------util_getPostDataFetchKey---------3-",keyData);
        //         }
        //     }   
        //     if(d == 0)
        //     {
        //         //noProfile();
        //     }                 
        // })        
        // .catch((error) => {
        //     console.log("util_getPostDataFetchKey-",error);
        //     //noProfile();
        // });

        //console.log("-------util_getPostDataFetchKey---------2-");
        //return keyData;
    }
    catch (e) {
        console.log("util_getPostDataFetchKey-e ", e);
    }
};

// urlify + hashify + tagiify in single pass
function parseTextSinglePass(text) {
    const combinedRegex = /(\bhttps?:\/\/[^\s<]+|\bwww\.[^\s<]+)|(#\w+)|(@[\w.]+)/gi;

    return text.replace(combinedRegex, (match, url, hash, tag) => {
        if (url) {
            let withProtocol = url.startsWith("http") ? url : "http://" + url;
            return `<a href="${withProtocol}" target="_blank">${url}</a>`;
        } else if (hash) {
            return `<span style="color:#2d97f7">${hash}</span>`;
        } else if (tag) {
            return `<span style="color:#2d97f7">${tag}</span>`;
        }
        return match;
    });
}

export { 
    util_getPostDataFetchKey,
    util_isObjectEmpty, 
    util_isObjectNotEmpty,
    util_isEmpty,
    util_isNotEmpty,
    parseTextSinglePass
};